// extracted by mini-css-extract-plugin
export default {"clickableOption":"ResourcePicker_clickableOption__E2e1m"};